<script setup lang="ts">
import { computed } from 'vue';
import ZAvatar from '@pwa-shared/components/ui/ZAvatar.vue';
import { useDelivererStore } from '../../stores/deliverer';

const store = useDelivererStore();

const isAvailable = computed(() => store.profile?.status === 'available');

const vehicleLabel = computed(() => {
    const map: Record<string, string> = {
        moto: 'Moto',
        bicicleta: 'Bicicleta',
        carro: 'Carro',
        a_pe: 'A pé',
    };
    return store.profile?.vehicle_type ? (map[store.profile.vehicle_type] ?? store.profile.vehicle_type) : null;
});
</script>

<template>
    <header class="flex items-center gap-3 px-4 pb-4 sticky top-0 z-10"
        style="background: #fff; border-bottom: 1px solid #F1F2F4; padding-top: calc(env(safe-area-inset-top, 0px) + 12px);">

        <template v-if="store.loading">
            <div class="w-10 h-10 rounded-full bg-gray-100 animate-pulse flex-shrink-0" />
            <div class="flex-1 space-y-2">
                <div class="h-3 bg-gray-100 rounded w-32 animate-pulse" />
                <div class="h-2.5 bg-gray-100 rounded w-24 animate-pulse" />
            </div>
        </template>

        <template v-else-if="store.error">
            <p class="text-[12px] font-semibold" style="color:#EF4444;">{{ store.error }}</p>
        </template>

        <template v-else-if="store.profile">
            <ZAvatar
                :name="store.profile.name"
                :src="store.profile.photo_url ?? undefined"
                size="md"
                :style="!store.profile.photo_url && !isAvailable ? 'background: #9CA3AF; color: #fff;' : undefined"
            />

            <div class="flex-1 min-w-0">
                <p class="text-[15px] font-bold leading-tight truncate" style="color: #111827;">
                    {{ store.profile.name }}
                </p>
                <div class="flex items-center gap-[5px] mt-[3px]">
                    <span
                        class="inline-block w-2 h-2 rounded-full flex-shrink-0"
                        :style="{ background: isAvailable ? '#22C55E' : '#9CA3AF' }"
                    />
                    <span class="text-[12px] font-medium" style="color: #6B7280;">
                        {{ isAvailable ? 'Online' : 'Offline' }}
                        <template v-if="vehicleLabel"> · {{ vehicleLabel }}</template>
                        <template v-if="store.profile.license_plate"> · {{ store.profile.license_plate }}</template>
                    </span>
                </div>
            </div>

        </template>
    </header>
</template>
